"use client";

import { createContext, useContext } from "react";
import type { PropsWithChildren } from "react";
import { CircularProgress } from "@mui/material";
import dynamic from "next/dynamic";
import styles from "./NoSSR.module.scss";

interface NoSSRContextType {
  loaderWidth?: string;
  loaderHeight?: string;
  showLoader?: boolean;
}

const NoSSRContext = createContext<NoSSRContextType>({});

const NoSSRDynamic = dynamic<PropsWithChildren>(() => import("@/src/component/partial/NoSSR/NoSSRComponent"), {
  ssr: false,
  loading: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const noSSRContext = useContext(NoSSRContext);
    return (
      <div
        style={{
          height: noSSRContext?.loaderHeight,
          width: noSSRContext?.loaderWidth,
          display: !noSSRContext?.showLoader ? "none !important" : undefined,
        }}
        className={styles.noSSRLoadingLayout}
      >
        <CircularProgress size={80} />
      </div>
    );
  },
});

interface NoSSRProps extends NoSSRContextType {}

function NoSSR({ children, loaderWidth, loaderHeight, showLoader }: PropsWithChildren<NoSSRProps>) {
  return (
    <NoSSRContext.Provider
      value={{
        loaderWidth,
        loaderHeight,
        showLoader,
      }}
    >
      <NoSSRDynamic>{children}</NoSSRDynamic>
    </NoSSRContext.Provider>
  );
}

export default NoSSR;
